module.exports = __webpack_public_path__ + "img/普陀男.56ce6b31.png";